import { Container } from '../Invitations.styles';

const InvitationsError = () => {
  return <Container>Error on load invitations</Container>;
};

export { InvitationsError };
